import { ResourcesTabsBar } from '@features/Contractor/components/ResourcesTabsBar'
import { ForestCrewStatusFilter } from '@features/Contractor/Resources/ForestCrewStatusFilter'
import { MachineStatusFilter } from '@features/Contractor/Resources/MachineStatusFilter'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate'
import { useTranslations } from '@utils/i18n-to-migrate/useTranslations'
import { ForestCrewFilterProvider } from '@/contexts/ForestCrewFilterContext'
import { MachineFilterProvider } from '@/contexts/MachineFilterContext'

const ResourcesLayout: React.FC = () => {
  const { t: tCard } = useTranslations()
  return (
    <MachineFilterProvider>
      <ForestCrewFilterProvider>
        <div className="flex min-w-0 flex-col gap-6 overflow-hidden rounded-xl border bg-background p-6 shadow-sm">
          <div className="flex flex-col gap-1.5">
            <div className="font-family-font-headings font-bold text-base leading-none tracking-tight text-card-foreground">
              {tCard('contractor-resources.card.title')}
            </div>
            <div className="h-px bg-border" />
            <p className="text-sm leading-5 text-muted-foreground">
              {tCard('contractor-resources.card.description')}
            </p>
          </div>
          <div className="flex min-w-0 flex-col gap-6 overflow-hidden">
            <div className="flex items-center justify-between gap-4">
              <ResourcesTabsBar />
              <div className="flex items-center gap-2">
                <MachineStatusFilter />
                <ForestCrewStatusFilter />
              </div>
            </div>
            <Outlet />
          </div>
        </div>
      </ForestCrewFilterProvider>
    </MachineFilterProvider>
  )
}

export const Route = createFileRoute('/contractor/$contractorId/resources')({
  component: ResourcesLayout,
  staticData: {
    breadcrumb: t('contractor.profile.resources.breadcrumb'),
  },
})
